import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';

import { catchError } from 'rxjs/operators';

@Injectable()
export class ApiService {
  constructor(
    private http: HttpClient,
  ) { }


  baseRetry: number = 4;

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(`${environment.urlAPI}${path}`, { params })
      .pipe(catchError(this.formatErrors));
  }

  put(path: string, body: Object = {}): Observable<any> {
    const url = `${environment.urlAPI}${path}`;  
    return this.http.put(url,body).pipe(
      catchError((error) => {
        console.error('Error capturado:', error);
        return throwError(() => error); // Re-lanza el error
      })
    );
  }
  

  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
      `${environment.urlAPI}${path}`,
      JSON.stringify(body)
    ).pipe(catchError(this.formatErrors));
  }

  delete(path: any): Observable<any> {
    return this.http.delete(
      `${environment.urlAPI}${path}`
    ).pipe(catchError(this.formatErrors));
  }

  isJsonString(strJson: string): boolean {
    // Validar JSON
    try {
      JSON.parse(strJson);
    } catch (e) {
      return false;
    }
    return true;
  }

  isError(resData: any, errorName: string): any {
    // Validar datos de JSON, Error...
    if (this.isJsonString(JSON.stringify(resData))) {
      if (resData == null || resData == undefined) {
        return { is: false, msg: 'Answer with error' };
      } else if (resData instanceof Array) {
        return { is: true, msg: 'Ok Array' };
      } else if (resData.hasOwnProperty('data')) {
        if (resData.data == null || resData.data == undefined) {
          return { is: false, msg: 'Answer with error' };
        } else if (resData.data instanceof Array) {
          return { is: true, msg: 'Ok Array' };
        } else if (resData.data.hasOwnProperty('Status')) {
          if (resData.data.Status == false) {
            localStorage.clear();
            sessionStorage.clear();
            // window.location.href = this.url_Base + "/users/login";
            return { is: false, msg: 'Answer with error' };
          } else {
            return { is: true, msg: 'Ok Value' };
          }
        } else {
          return { is: true, msg: 'Ok Value' };
        }
      } else {
        return { is: true, msg: 'Ok Value' };
      }
    } else {
      return { is: false, msg: 'Invalid json response' };
    }
  }

  isErrorLambda(resData: any): any {
    if (this.isJsonString(JSON.stringify(resData))) {
      if (resData == null || resData == undefined) {
        return { is: false, msg: 'Respond with null or undefined' };
      } else if (resData.hasOwnProperty('status')) {
        if (resData.status) {
          if (resData.hasOwnProperty('data')) {
            return { is: true, msg: 'Ok Value' };
          } else {
            return { is: false, msg: 'Response does not contain the [data] property' };
          }
        } else {
          return { is: false, msg: 'Response contains false value in [status] property' };
        }
      } else {
        return { is: false, msg: 'Response does not contain the [status] property' };
      }
    } else {
      return { is: false, msg: 'Response does not contain a valid json' };
    }
  }

  valData(type: number, params: any): any {
    switch (type) {
      case 0:
        // Default
        return this.isError(params.x, 'Error');
      case 1:
        return this.isError(params.x, params.y);
      case 2:
        return this.isErrorLambda(params);
      default:
        return {
          is: false,
          msg: 'Invalid parameter type:(' + type + ') in valData'
        };
    }
  }


  public handleError<T>(operation = 'operation', result?: T, error?: any) {
    // TODO: send the error to remote logging infrastructure
    // console.log(error); // log to console instead

    // TODO: better job of transforming error for user consumption
    this.log(`${operation} failed: ${error.message}`);
    // Let the app keep running by returning an empty result.
    return of(result as T);

  }

  private log(message: string) {
    console.log(`%c * Error * `, 'color:red; font-size:13px', message);
  }

}
